import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { fetchTemplateCause } from '../template-actions';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import { useDispatch, useSelector } from 'react-redux';
import { hasWindow } from '../../utils';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import { hideIntercomBubble } from '../../support-and-tracking/intercom-actions';
import { OrganizationTemplateEmbedCard } from './OrganizationTemplateEmbedCard';
import { OrganizationTheme } from '../../organization/theme/OrganizationTheme';
import { fetchOrganization } from '../../organization/organization-actions';
import OrganizationContext from '../../organization/organization-context';
import { getOrganizationById } from '../../organization/organizations-reducer';

function sendSize() {
    const app = document.querySelector('body');

    parent.postMessage({ height: app.offsetHeight, width: app.offsetWidth }, '*');
}

const EmbedCause = () => {
    const { causeId } = useParams();
    const dispatch = useDispatch();
    const [cause, setCause] = useState();

    useEffect(() => {
        if (hasWindow()) {
            window.addEventListener('DOMContentLoaded', sendSize);
            window.addEventListener('resize', sendSize);
        }
        trackPageView({ urlAsEvent: 'cause-embed', properties: { 'cause-id': causeId } });
    }, []);

    useEffect(() => {
        dispatch(fetchTemplateCause({ causeId })).then((cause) => setCause(cause));
    }, [causeId, dispatch]);

    useEffect(() => {
        if (cause?.organization_id) {
            dispatch(fetchOrganization(cause.organization_id));
        }
    }, [cause?.organization_id]);

    const organization = useSelector((state) => getOrganizationById(state, cause?.organization_id));

    useEffect(() => {
        hideIntercomBubble();
    }, []);

    if (cause?.id) {
        return (
            <OrganizationContext.Provider
                value={{
                    themeColor: organization?.profile?.themeColor,
                }}
            >
                <OrganizationTheme>
                    <OrganizationTemplateEmbedCard
                        key={cause.id}
                        causeId={cause.id}
                        templateId={cause.template_id}
                        title={cause.title}
                        description={cause.description}
                        img_url={cause.img_url}
                        dugnad={cause.dugnad}
                        birthday={cause.birthday}
                        customLink={cause.profile?.customLink}
                        customLinkText={cause.profile?.customLinkText}
                        startProjectText={cause.profile?.startProjectText}
                    />
                </OrganizationTheme>
            </OrganizationContext.Provider>
        );
    } else {
        return <LoaderBar />;
    }
};

export default EmbedCause;
